import { format, isValid } from "date-fns";
import { Text } from "../../Type";

const DateCell = ({ value }: { value: string }) => {
  const date = value ? new Date(value) : null;
  if (!date || !isValid(date)) {
    return <Text size="small">—</Text>;
  }
  return (
    <>
      <Text size="small" lineHeight="medium">
        {format(date, "MM/dd/yyyy")}
      </Text>
      <Text size="small" fade>
        {format(date, "hh:mm a")}
      </Text>
    </>
  );
};

export default DateCell;
